import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TableLayout from "../../../components/TableLayout";
import TableActions from "../../../components/Common/TableActions";
import { ROOMTYPE, ROOMTYPEDELETE } from "../../../services/ApiCalls";
import dataHandler from "../../../hooks/dataHandler";
import moment from "moment";
import Filter from "../../../components/Common/Filter";
import {
  activeInactiveOptions,
  defaultDeleteModelState,
} from "../../../utilities/const";
import { Link } from "react-router-dom";

import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import CustomPagination from "../../../components/Common/CustomPagination";

const RoomType = () => {
  const { t } = useTranslation();
  const {
    setBody,

    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    setCommisionModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: ROOMTYPE,
  });

  const column = [
    {
      head: t("roomType.columns.serialNumber"),
      accessor: "#",
      component: (item, key) => {
        return <>{key < 9 ? `0${key + 1}` : key + 1}</>;
      },
    },

    {
      head: t("roomType.columns.image"),
      accessor: "imageUrl",
      component: (item) => {
        return (
          <>
            <img
              className="img-fluid w-25 h-25"
              src={item?.imageUrl}
              alt={item?.name}
            />
          </>
        );
      },
    },

    {
      head: t("roomType.columns.roomType"),
      accessor: "name",
    },

    // {
    //   head: "Description",
    //   accessor: "description",
    // },

    {
      head: t("roomType.columns.createdAt"),
      accessor: "createdAt",
      component: (item, key) => {
        return (
          <>
            <p>{moment(item.createdAt).format("YYYY-MM-DD")}</p>
          </>
        );
      },
    },

    {
      head: t("roomType.columns.status"),
      accessor: "status",
      component: (item, key, arr) => (
        <span className="">{item?.status ? item?.status : "--"}</span>
      ),
    },
    {
      head: t("roomType.columns.action"),
      accessor: "Action",
      component: (item) => {
        console.log(item, "item");
        return (
          <TableActions
            editUrl={`/roomtype/edit/${item._id}`}
            // viewLink={`/roomtype/detail/${item._id}`}
            setDeleteModel={() =>
              setDeleteModel({ show: true, dumpId: item?._id })
            }
          />
        );
      },
    },
  ];

  const [confirmation, setConfirmation] = useState();
  const handleConfirmation = () => setConfirmation(!confirmation);

  return (
    <>
      <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel((p) => defaultDeleteModelState)}
        confirmHandler={() =>
          deleteHandler(() => ROOMTYPEDELETE({ _id: deleteModel.dumpId }))
        }
      />
      <section className="promocode py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                {t("roomType.title")}
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    setBody={setBody}
                    searchHandler={searchHandler}
                    statusFilterOptionArr={activeInactiveOptions}
                  />
                </div>
                <div className="right">
                  <Link
                    to="/roomtype/add"
                    className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                    style={{ height: 40, minWidth: 100, fontSize: 12 }}
                  >
                    {t("roomType.buttons.addNew")}
                  </Link>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default RoomType;
